import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type IntlService from 'ember-intl/services/intl';
import TeamModel from 'scaleflow/models/team';
import type BetaToggleService from 'scaleflow/services/beta-toggle';

type Tab = {
  label: string;
  route: string;
  key: string;
};

export default class OperationsTeamsTeamController extends Controller {
  @service declare router: RouterService;
  @service declare intl: IntlService;
  @service declare betaToggle: BetaToggleService;
  declare model: TeamModel;

  get team() {
    return this.model;
  }

  get tabs(): Tab[] {
    const tabs = [
      {
        label: 'Home',
        route: 'operations.teams.team.home',
        key: 'home',
      },
      {
        label: 'Goals',
        route: 'operations.teams.team.goals',
        key: 'goals',
      },
      {
        label: 'Roadmap',
        route: 'operations.teams.team.roadmap',
        key: 'roadmap',
      },
      {
        label: 'Initiatives',
        route: 'operations.teams.team.initiatives',
        key: 'initiatives',
      },
      {
        label: 'Settings',
        route: 'operations.teams.team.settings',
        key: 'settings',
      },
    ];

    if (this.betaToggle.showCheckin) {
      tabs.splice(4, 0, {
        label: 'Check-in',
        route: 'operations.teams.team.check-in',
        key: 'check-in',
      });
    }
    return tabs;
  }

  @action
  isActive(tab: Tab) {
    return this.router.currentRouteName?.includes?.(tab.key);
  }
}
